import { memo, useContext, useState } from "react";
// @mui
import { useTheme } from "@mui/material/styles";
import {
  AppBar,
  Avatar,
  Box,
  BoxProps,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography
} from "@mui/material";
// config
import { HEADER } from "../../../../../minimals/config-global";
// utils
import { bgBlur } from "../../../../../minimals/utils/cssStyles";
// components
import { NavSectionHorizontal } from "../../../../../minimals/components/nav-section";
//
import { getNavConfig } from "./config-navigation";
import Logo from "../../../../../minimals/components/logo";
import { UserContext } from "../../../../contexts/UserContext";

// ----------------------------------------------------------------------

const logout = () => {
  window.location.href = "/api/login/logout";
};

function NavHorizontal() {
  const theme = useTheme();
  const { user } = useContext(UserContext);
  const [accountMenuAnchor, setAccountMenuAnchor] = useState<HTMLElement | null>(null);
  const isExchangeUser =
    user?.roles?.find((role) => role.isPrimaryRole)?.internalUserDepartment?.name === "Madex";

  return (
    <AppBar
      component="nav"
      color="transparent"
      sx={{
        boxShadow: 0
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default
          })
        }}
      >
        <Logo />
        <Box sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          <NavSectionHorizontal data={getNavConfig(user?.email, isExchangeUser)} />
        </Box>
        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          <Tooltip title={user?.name ?? ""}>
            <IconButton
              onClick={(event) => setAccountMenuAnchor(event.currentTarget)}
              sx={{ p: 0 }}
            >
              <Avatar
                sx={{
                  width: 36,
                  height: 36,
                  fontSize: 14,
                  fontWeight: 500,
                  color: "common.white",
                  backgroundColor: "primary.dark"
                }}
              >
                {user?.initials}
              </Avatar>
            </IconButton>
          </Tooltip>

          <Menu
            open={Boolean(accountMenuAnchor)}
            anchorEl={accountMenuAnchor}
            onClose={() => setAccountMenuAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            slotProps={{ paper: { sx: { minWidth: 200, mt: 1 } } }}
          >
            <Box sx={{ px: 2, py: 1 }}>
              <Typography variant="subtitle2" noWrap>
                {user?.name}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
                {user?.email}
              </Typography>
            </Box>

            <Divider sx={{ borderStyle: "dashed" }} />

            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
      <Shadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);

// ----------------------------------------------------------------------

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        width: 1,
        m: "auto",
        borderRadius: "50%",
        position: "absolute",
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx
      }}
      {...other}
    />
  );
}
